/**
 * Detect if the user is on macOS
 * Uses modern User-Agent Client Hints API with fallback to userAgent
 */
export const isMacOS = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    // Use modern User-Agent Client Hints API if available
    if (navigator.userAgentData?.platform) {
        const platform = navigator.userAgentData.platform.toLowerCase();
        return platform.includes('mac');
    }

    // Fallback to userAgent for older browsers
    if (navigator.userAgent) {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('mac');
    }

    return false;
};

/**
 * Get keyboard shortcut keys based on OS
 * Returns array of keys to display separately
 */
export const getKeyboardShortcutKeys = () => {
    if (isMacOS()) {
        return ['⌘', 'K'];
    }
    return ['CTRL', 'K'];
};
